<template>
  <div>
    <main-layout
      controlsBg="light"
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row  class="margin-top-xl" column-align="center">
          <grid-col col-size="4">
            <div id="header">
              <h1 class="header-title">
                <chevron
                  @click="$router.push({name: origin})"/>
                {{ $t('events.title') }}
              </h1>
            </div>
          </grid-col>
        </grid-row>
        <grid-row
          column-align="center">
          <grid-col
            col-size="4">
            <div
              style="display: flex; justify-content: right">
              <tags-filter
                v-model="filterTags"
                :tagsTree="getTagsTreeState"/>
            </div>
          </grid-col>
        </grid-row>
        <grid-row  class="margin-top-m" column-align="center">
          <grid-col col-size="4">
            <table-component
              ref="eventsTable"
              :data="fetchData"
              sort-by="lastActivation"
              sort-order="desc"
              :show-caption="false"
              show-filter=false
              class="datatable"
              filter-placeholder=""
              filterNoResults="">
              <!--
              WARNING
              <table-column
              :sortable="false"
              :filterable="false"
              header-class="table-component__minimum__width__column"
              cell-class="text-center">
              <template slot-scope="row">
              <span>
              v-tooltip.right.top-start="{
                content: displayFormula(row)
              }">
                  <font-awesome-icon
                    :id="row"
                    :icon="icon.viewRule"/>
                  </span>
                </template>
              </table-column>
              -->
              <table-column
                show="name"
                header-class="text-left"
                cell-class="table-component__text-left"
                :label="$t('events.name')">
                <template slot-scope="row">
                  <span
                    v-on:click="onClickEvent(row)"
                    class="event-clickable">
                      {{ nameFormatter(row) }}
                  </span>
                </template>
              </table-column>
              <table-column
                show="firstActivation"
                cell-class="table-component__text-center"
                :label="$t('events.firstActivation')"
                :formatter="dateFormatter">
              </table-column>
              <table-column
                show="lastActivation"
                cell-class="table-component__text-center"
                :formatter="dateFormatter"
                :label="$t('events.lastActivation')">
              </table-column>
              <table-column
                :label="$t('variables.tags')"
                :filterable="false"
                :sortable="false">
                <template
                  slot-scope="row">
                  <tags
                    :value="row.tags" />
                </template>
              </table-column>
            </table-component>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '../MainLayout';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import {mapGetters, mapActions} from 'vuex';
import {
  faSlidersH
} from '@fortawesome/pro-regular-svg-icons';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import TableComponent from '@/components/shared/table/components/TableComponent';
import TableColumn from '@/components/shared/table/components/TableColumn';
import dayjs from 'dayjs';
import eventApi from '@/api/event';
import Tags from '@/components/variable/Tags';
import TagsFilter from '@/components/variable/TagsFilter';
import Chevron from '@/components/shared/Chevron';
import config from 'BRAND/config';
import localizedFormat from 'dayjs/plugin/localizedFormat';

export default {
  name: 'EventList',
  components: {
    TagsFilter,
    Tags,
    MainLayout,
    GridRow,
    GridCol,
    TableComponent,
    TableColumn,
    FontAwesomeIcon,
    Chevron
  },
  created () {
    dayjs.extend(localizedFormat);
    const tags = this.$route.query.tags;
    if (tags) {
      this.filterTags = tags.split(',');
    }
    if (this.$route.query.origin) {
      this.origin = this.$route.query.origin;
    }
    // WARNING this.retrieveVariables({context: this});
    this.retrieveTagsTree({context: this});
  },
  data () {
    return {
      icon: {
        viewRule: faSlidersH
      },
      page: 1,
      filter: '',
      sort: {
        fieldName: '',
        order: 'desc'
      },
      filterTags: [],
      origin: 'Workspace'
    };
  },
  watch: {
    filterTags: {
      handler: function () {
        const query = this.filterTags.length === 0 ? {origin: this.origin} : { tags: this.filterTags.join(','), origin: this.origin };
        this.$router.push({ query: query });
        this.$refs.eventsTable.refresh();
      }
    }
  },
  computed: {
    ...mapGetters([
      'getVariables',
      'getLanguageCode',
      'getTagsTreeState'
    ]),
    getBreadcrumb () {
      const personalArea = this.$t('menu.workspace');
      const events = this.$t('events.title');
      let origin = {};
      switch (this.origin) {
        case 'CellCurrentStatus':
          origin = {name: this.$t('gkn.currentStatus') + ' > TS4', link: '/gkn/cell/current-status'};
          break;
        case 'InsertecCurrentStatus':
          origin = {name: this.$t('currentStatus.status'), link: '/current-status'};
          break;
        default:
          origin = {name: personalArea, link: '/workspace'};
      }
      return [
        origin,
        {name: events, link: '/event/list', disabled: true}
      ];
    }
  },
  methods: {
    ...mapActions([
      'retrieveVariables',
      'retrieveTagsTree'
    ]),
    dateFormatter (value) {
      const languageCode = this.getLanguageCode;
      return dayjs(new Date(value * 1000)).locale(languageCode).format('LLL');
    },
    nameFormatter (row) {
      return row.name + ' (' + row.eventTimes.length + ')';
    },
    fetchData ({filter, sort, page}) {
      if (filter !== this.filter || sort.fieldName !== this.sort.fieldName || sort.order !== this.sort.order) {
        page = 1;
      }
      this.filter = filter;
      this.page = page === null || isNaN(page) ? 1 : page;
      this.sort.fieldName = sort.fieldName;
      this.sort.order = sort.order;
      const unionTagFilter = config.routes.find(route => route.name === 'InsertecCurrentStatus') !== undefined;
      return retrieveEventsPaginated({context: this, page: this.page, filter: filter, order: sort, tags: this.filterTags, unionTagFilter: unionTagFilter});
    },
    displayFormula (row) {
      const formulaJson = JSON.parse(row.formula);
      const formulaArray = formulaJson.formula.split(' ');
      formulaJson.variables.forEach(variable => {
        const variableInfo = getVarById(this.getVariables, variable.id);
        if (variableInfo) {
          const variableLabel = variableInfo.label;
          formulaArray.splice(formulaArray.indexOf(variable.key), 1, variableLabel);
        }
      });
      return formulaArray.join(' ');
    },
    onClickEvent (row) {
      const query = {
        variables: JSON.parse(row.formula).variables.map(variable => variable.id).join(),
        startDate: row.firstActivation * 1000,
        endDate: row.lastActivation * 1000,
        origin: this.origin,
        tags: this.filterTags
      };

      this.$router.push({name: 'ExplorerEvolution', query: query});
    }
  }
};

const retrieveEventsPaginated = ({context, page, filter, order, tags, unionTagFilter}) => {
  return new Promise((resolve, reject) => {
    eventApi.getPaginatedEvents(context, page, filter, order, tags, unionTagFilter)
      .then(data => {
        resolve({
          data: data.eventSummaries,
          pagination: {
            totalPages: data.totalPages,
            currentPage: data.currentPage,
            count: data.count
          }
        });
      }, error => {
        reject(error);
      });
  });
};

const getVarById = (list, ref) => {
  const id = Number(ref);
  for (let i = 0; i < list.length; i++) {
    if (id === list[i].value.id) {
      return list[i];
    }
  }
};
</script>

<style lang="scss">
  @import "src/stylesheets/variables";

  .event-clickable {
    cursor: pointer;
    color: $link;
  }

</style>



// WEBPACK FOOTER //
// src/layouts/events/EventList.vue